import React, { memo, useEffect } from 'react'
import tw, { css } from 'twin.macro'
import { Typography } from '@mui/material'
import SuccessImage from 'src/assets/images/success.png'
import { ClientPublicWrapper } from 'src/components/layout/client/ClientPublicWrapper'

interface Props {
  title?: string
  description?: string
}

const OnboardingSuccessPageComponent = ({ title, description }: Props) => {
  useEffect(() => {
    window.parent.postMessage(
      {
        type: 'onboarding_completed',
      },
      '*',
    )
  }, [])

  return (
    <ClientPublicWrapper isShowGigSafeMemberBenefitPortal={true}>
      <div css={tw`h-full flex flex-col justify-between px-4 min-w-[360px]`}>
        <img src={SuccessImage} css={tw`h-[220px] w-[280px] self-center`} />
        <div>
          <Typography css={tw`my-4 text-center`} variant="h2">
            {title ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: title,
                }}
              />
            ) : (
              'Your document submission was successful!'
            )}
          </Typography>
          <Typography css={tw`text-center text-shades-400`}>
            {description ? (
              <div
                css={styles.descriptionContainer}
                dangerouslySetInnerHTML={{
                  __html: description,
                }}
              />
            ) : (
              'We will keep you informed about your status through SMS notifications.'
            )}
          </Typography>
        </div>
      </div>
    </ClientPublicWrapper>
  )
}

export const OnboardingSuccessPage = memo(OnboardingSuccessPageComponent)

const styles = {
  descriptionContainer: css`
    > p {
      margin-top: 8px;
      margin-bottom: 8px;
    }
    > h4 {
      margin-top: 8px;
      margin-bottom: 8px;
    }
  `,
}
